import React, {useEffect, useState} from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Home from "../Routes/Home";
import FAQ from "../Components/FAQ";
import SignIn from "../Routes/Sign/Signin";
import SignUp from "../Routes/Sign/Signup";
import Partners from "../Routes/Partners";
import Profile from "../Routes/Profile";
import Devices from "../Routes/Devices";
import Detail from "../Routes/Detail";
import styled, {keyframes} from 'styled-components';
// import { useUserState } from "../redux/constants/userContext";

import ReactGA from 'react-ga';

ReactGA.initialize('UA-188316786-1');

const Spin = keyframes`
  from {
    transform: rotate(0);
  }
  to{
    transform: rotate(359deg);
  }
`

const SpinnerBox = styled.div`
  width: 300px;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -150px;
  margin-top: -150px;
  align-items: center;
  z-index: 999;
  background-color: transparent;
`

const CircleBorder = styled.div`
  width: 150px;
  height: 150px;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: transparent;
  background: linear-gradient(0deg, rgba(254,112,49,0.1) 33%, rgba(254,112,49,1) 100%);
  animation: ${Spin} .8s linear 0s infinite;
`

const CircleCore = styled.div`
  width: 100%;
  height: 100%;
  /* background-color: black; */
  background-color: transparent;
  opacity: 0.5;
  border-radius: 50%;
  z-index: 101;
`

const CircleText = styled.div`
  margin-top: 10px;
  color: white;
`

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: black;
  opacity: 0.9;
`


export default () => {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    
  } ,[])


  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000)
  }, [])

  return (
    <Router>
      <>
        {loading && (
          <>
            <SpinnerBox>
              <CircleText>전 세계 시계 거래데이터를 취합하고 있습니다.</CircleText>
              <CircleText>잠시만 기다려주세요.</CircleText>
            </SpinnerBox>
            
            <Container></Container>
          </>
        )}
        <Header />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/signin" exact component={SignIn} />
          <Route path="/signup" exact component={SignUp} />
          <Route path="/partners" exact component={Partners} />
          {/* <Route path="/shop" exact component={Profile} /> */}
          <Route path="/shop/profile" exact component={Profile} />
          {/* <PrivateRoute path="/profile" exact component={Profile} /> */}
          <Redirect from="*" to="/" />
        </Switch>
        <Footer />
      </>
    </Router>
  )
};
